import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor'
import PageState, { ITextTemplateItem } from '../../store/state'
import { Prop, Watch } from 'vue-property-decorator'
import { debouncedSaveArticle } from '../../utils/utils'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class TextTemplate extends Vue {
  @Prop({default: false})
  isEditing: boolean

  @Watch('isEditing')
  listenIsEditing(val) {
    console.log('isEditing', val)
  }

  state = new PageState()

  created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
  }

	/****************************** 文字模板 ******************************/

	// 当前的文字模板
	get operatingTextTemplateItem() {
		let textTemplate: ITextTemplateItem = {}
		this.state.defaultTextTemplateList.forEach(item => {
			if (item.id === this.state.operatingTextTemplate.id) {
				textTemplate = item
			}
		})
		return textTemplate
	}

  get textTemplateTextList() {
    return this.state.operatingTextTemplate.text.split('')
  }

  get gridTemplateColumns() {
    switch(this.operatingTextTemplateItem.direction) {
      case 'row':
        return {
          'display': 'flex',
          'flex-direction': this.operatingTextTemplateItem.direction
        }
      case 'column':
        return {
          'display': 'flex',
          'flex-direction': this.operatingTextTemplateItem.direction
        }
      case 'table':
        return {
          'display': 'grid',
          'grid-template-columns': `repeat(${ this.operatingTextTemplateItem.column }, 1fr)`,
          'grid-template-rows': `repeat(${ this.operatingTextTemplateItem.maxLength / (this.operatingTextTemplateItem.column || 1) }, 1fr)`
        }
      default:
        return 'repeat(1, 1fr)'
    }
  }

  /** 选择文字模板 */
  handleSelectTextTemplate() {
    this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, true)
    this.$bus.$emit(this.$EventBusKey.EDIT_TEXT_TEMPLATE)
  }

	/****************************** 拖拽模板 ******************************/

  // 移动是/否开始
  isTouchStarted = false
  // X/Y 轴起始点
  startX = 0
  startY = 0
  // 起始 left/top 距离
  startOffsetLeft = 0
  startOffsetTop = 0
  // 文字模板宽/高
  textTemplateWidth = 0
  textTemplateHeight = 0
  // 视频播放容器宽/高
  containerWidth = 0
  containerHeight = 0

  handleTouchStart(event) {
    if (!this.isEditing) return
    // 设置起始的 X Y 轴位置
    const touchInfo = event.targetTouches[0]
    this.startX = touchInfo.pageX
    this.startY = touchInfo.pageY
    // 设置起始的 offsetLeft offsetTop 值
    // 设置正在移动状态
    this.isTouchStarted = true
    // 播放器容器宽高
    const container = document.getElementById('videoImgCanvas') as HTMLCanvasElement
    this.containerWidth = container.clientWidth
    this.containerHeight = container.clientHeight
    // 处理边界问题
    const textTemplateContainer = document.getElementById('textTemplateContainer') as HTMLElement
    this.textTemplateWidth = textTemplateContainer.clientWidth
    this.textTemplateHeight = textTemplateContainer.clientHeight
    this.startOffsetLeft = textTemplateContainer.offsetLeft
    this.startOffsetTop = textTemplateContainer.offsetTop
  }

  handleTouchMove(event) {
    if (this.isTouchStarted) {
      const touchInfo = event.targetTouches[0]
      const translateX = touchInfo.pageX - this.startX
      const translateY = touchInfo.pageY - this.startY
      // 边界问题
      if (this.startOffsetLeft + translateX <= 0) {
        // 左侧边界
        this.state.operatingTextTemplate.x = 0
      } else if (this.startOffsetLeft + translateX > this.containerWidth - this.textTemplateWidth) {
        // 右侧边界
        this.state.operatingTextTemplate.x = (this.containerWidth - this.textTemplateWidth) / this.containerWidth
      } else {
        // 安全区域
        this.state.operatingTextTemplate.x = this.state.savedTextTemplate.x + (translateX / this.containerWidth)
      }
      if (this.startOffsetTop + translateY <= 0) {
        // 上方边界
        this.state.operatingTextTemplate.y = 0
      } else if (this.startOffsetTop + translateY > this.containerHeight - this.textTemplateHeight) {
        // 下方边界
        this.state.operatingTextTemplate.y = (this.containerHeight - this.textTemplateHeight) / this.containerHeight
      } else {
        // 安全区域
        this.state.operatingTextTemplate.y = this.state.savedTextTemplate.y + (translateY / this.containerHeight)
      }
    }
  }

  handleTouchEnd() {
    if (this.isTouchStarted) {
      this.state.savedTextTemplate.x = this.state.operatingTextTemplate.x
      this.state.savedTextTemplate.y = this.state.operatingTextTemplate.y
      // 取消正在移动状态
      this.isTouchStarted = false
      // 保存文章
      debouncedSaveArticle(this)
    }
  }

	/****************************** 缩放模板 ******************************/

  // 移动是/否开始
  isScaleTouchStarted = false
  // 缩放起始点 X/Y 轴
  scaleStartX = 0
  scaleStartY = 0

  handleScaleTouchStart(event) {
    if (!this.isEditing) return
    // 设置起始的 X Y 轴位置
    const touchInfo = event.targetTouches[0]
    this.scaleStartX = touchInfo.pageX
    this.scaleStartY = touchInfo.pageY
    // 设置正在移动状态
    this.isScaleTouchStarted = true
    // 播放器容器宽高
    const container = document.getElementById('videoImgCanvas') as HTMLCanvasElement
    this.containerWidth = container.clientWidth
    this.containerHeight = container.clientHeight
    // 处理边界问题
    const textTemplateContainer = document.getElementById('textTemplateContainer') as HTMLElement
    this.startOffsetLeft = textTemplateContainer.offsetLeft
    this.startOffsetTop = textTemplateContainer.offsetTop
  }

  handleScaleTouchMove(event) {
    if (this.isScaleTouchStarted) {
      const touchInfo = event.targetTouches[0]
      const translateX = touchInfo.pageX - this.scaleStartX
      const translateY = touchInfo.pageY - this.scaleStartY
      // 文字模板宽高
      const textTemplateWidth = this.state.operatingTextTemplate.width
      const textTemplateHeight = this.state.operatingTextTemplate.height
      // 边界问题
      if (this.state.savedTextTemplate.scale + translateX / textTemplateWidth <= 0.5) {
        this.state.operatingTextTemplate.scale = 0.5
      } else if (this.state.savedTextTemplate.scale + translateY / textTemplateHeight <= 0.5) {
        this.state.operatingTextTemplate.scale = 0.5
      } else if (this.state.savedTextTemplate.scale + translateX / textTemplateWidth >= 2) {
        this.state.operatingTextTemplate.scale = 2
      } else {
        this.state.operatingTextTemplate.scale = this.state.savedTextTemplate.scale + (translateX / textTemplateWidth)
      }
    }
  }

  handleScaleTouchEnd() {
    if (this.isScaleTouchStarted) {
      this.state.savedTextTemplate.scale = this.state.operatingTextTemplate.scale
      // 取消正在移动状态
      this.isTouchStarted = false
      // 保存文章
      debouncedSaveArticle(this)
    }
  }

}